<template>
  <Select v-model="selected" @on-change="handleChange">
    <Option v-for="opt in bomTypes" :value="opt.value" :key="opt.value">{{ opt.label }}</Option>
  </Select>
</template>

<script>
export default {
  name: 'BomTypeSelect',
  props: {
    value: {
      type: String,
      default: 'engineering_bom'
    }
  },
  data () {
    return {
      bomTypes: [
        { label: this.$t('bom_tool.engineering_bom'), value: 'engineering_bom' },
        { label: this.$t('bom_tool.cost_estimation_use'), value: 'cost_estimation_use' }
      ],
      selected: this.value
    }
  },
  methods: {
    handleChange (value) {
      this.$emit('input', value)
    }
  }
}
</script>
